import { memo, SVGProps } from 'react';

const NumberIcon_base = (props: SVGProps<SVGSVGElement>) => (
  <svg preserveAspectRatio='none' viewBox='0 0 84 234' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8.78971e-06 60.7252L60.7252 60.7252L83.8966 30.3626L60.7252 0L1.14441e-05 -2.65438e-06L8.78971e-06 60.7252ZM1.15727e-05 86.2938H60.7252L83.8966 116.656L60.7252 147.019H8.91831e-06L1.15727e-05 86.2938ZM1.15727e-05 172.587H60.7252L83.8966 202.95L60.7252 233.312H8.91831e-06L1.15727e-05 172.587Z'
      fill='url(#paint0_linear_1382_1234)'
    />
    <defs>
      <linearGradient
        id='paint0_linear_1382_1234'
        x1={-37.4044}
        y1={-37.3592}
        x2={177.546}
        y2={-47.3064}
        gradientUnits='userSpaceOnUse'
      >
        <stop offset={0.0700082} stopColor='#A782E9' />
        <stop offset={0.885332} stopColor='#86DFF0' />
      </linearGradient>
    </defs>
  </svg>
);

const Memo = memo(NumberIcon_base);
export { Memo as NumberIcon_base };
